<div>Forcast for: {{ selectedDate | date }}</div>

<kendo-treelist
  #treelist
  kendoTreeListExpandable
  [data]="rootData | async"
  [fetchChildren]="fetchChildren"
  [hasChildren]="hasChildren"
  [height]="800"
  expandBy="id"
  [expandedKeys]="initiallyExpanded"
  [loading]="loading"
  >
  <kendo-treelist-column
    [expandable]="true"
    [locked]="false"
    title="{{ 'EntityTranslation.Description' | translate }}"
    [width]="300"
    >
    <ng-template kendoTreeListCellTemplate let-dataItem> {{dataItem.materialDesc }} </ng-template>
  </kendo-treelist-column>
  <kendo-treelist-column title="Select Act" [width]="275" [expandable]="false">
    <ng-template kendoTreeListCellTemplate let-dataItem let-isExpanded>
      <kendo-multicolumncombobox
        [data]="dataItem.alternatives"
        textField="description"
        valueField="index"
        [valuePrimitive]="true"
        [value]="dataItem.selectedActivityIndex"
        (valueChange)="onActivityChange($event, dataItem)"
        [readonly]="!isExpanded"
        >
        <kendo-combobox-column field="description" title="Description" [width]="100"> </kendo-combobox-column>
        <kendo-combobox-column field="entyGroupCode" title="EntyGroupCode" [width]="100"> </kendo-combobox-column>
      </kendo-multicolumncombobox>
    </ng-template>
  </kendo-treelist-column>
  @for (l of [0, 1, 2, 3]; track l) {
    <kendo-treelist-column-group title="Level {{ l + 1 }}">
      <kendo-treelist-column title="Qty" [width]="75" [class]="'k-text-right'">
        <ng-template kendoTreeListCellTemplate let-dataItem>
          @if (dataItem.level === l) {
            <span class="k-text-right">
              {{ dataItem.qty | number: '1.2-2'}} {{ dataItem.qtyUnit }}
            </span>
          }
        </ng-template>
      </kendo-treelist-column>
      <kendo-treelist-column title="Forcast" [width]="75" [class]="'k-text-right'">
        <ng-template kendoTreeListCellTemplate let-dataItem>
          @if (dataItem.level === l && dataItem.forcast) {
            <span class="k-text-right">
              {{ dataItem.forcast | number: '1.2-2'}} {{ dataItem.qtyUnit }}
            </span>
          }
        </ng-template>
      </kendo-treelist-column>
    </kendo-treelist-column-group>
  }
</kendo-treelist>
